export default __webpack_public_path__ + "static/media/iconTopLeft.d1a1e1df.png";